// ** Kameralar
const initialKuzatuvState = {}

const Kuzatuv = (state = initialKuzatuvState, action) => {
  switch (action.type) {
    case "SET_KUZATUV_TYPES_CONTENT":
      return { ...action.val }
    default:
      return state
  }
}

export default Kuzatuv
